const ShoppingBasketIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="48" width="48">
      <path d="M9.8 42Q9 42 8.375 41.525Q7.75 41.05 7.55 40.3L1.9 19.95Q1.7 19.2 2.175 18.6Q2.65 18 3.45 18H13.45L22.7 4.5Q22.95 4.2 23.25 4.025Q23.55 3.85 23.95 3.85Q24.35 3.85 24.65 4.025Q24.95 4.2 25.2 4.5L34.4 18H44.65Q45.4 18 45.875 18.6Q46.35 19.2 46.15 19.95L40.45 40.3Q40.25 41.05 39.625 41.525Q39 42 38.2 42ZM17.1 18H30.75L23.95 8ZM10.3 39H37.7H10.3ZM24 33Q25.25 33 26.125 32.125Q27 31.25 27 30Q27 28.75 26.125 27.875Q25.25 27 24 27Q22.75 27 21.875 27.875Q21 28.75 21 30Q21 31.25 21.875 32.125Q22.75 33 24 33ZM10.3 39H37.7L42.75 21H5.3Z" />
    </svg>
  );
};

export default ShoppingBasketIcon;